import React from "react"
import GridContainer from "@/components/common/GridContainer"
import { getCssSizeValue, getIdWithoutSpecialSymbols, getMapKey, getPaddingsClassFromData } from "@/utils/utils"
import ColorfulSquare from "@/components/ColorfulSquares/ColorfulSquare"
import styled from "styled-components"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Container = styled(GridContainer)`
	//gap: 0;
	//row-gap: unset;
	@media (max-width: ${({ theme }) => theme.breakpoints.tablet - 1}px) {
		gap: ${getCssSizeValue(15, BREAKPOINTS.MOBILE)};
	}
`

// const Row = ({ data }) => {
// 	return  data.map((square, index) => (
// 		<ColorfulSquare
// 			key={getMapKey(square,index)}
// 			data={square}
// 			className={`col-mobile-8 col-tablet-4 col-desktop-6`}
// 		/>
// 	))
// }

const ColorfulSquares = ({ data }) => {
	const paddings = getPaddingsClassFromData(data)
	const squares = data?.squares || []
	const id = getIdWithoutSpecialSymbols(data?.id)
	// const rows  = useMemo(() => {
	// 	const source = data?.squares || []
	// 	return groupArrayBySize(source, 2)
	// } , [data])
	return (
		<Container id={id} className={`${paddings} indent-desktop-2`}>
			{/*{rows.map((row, index) => (*/}
			{/*	<Row*/}
			{/*		key={index}*/}
			{/*		data={row}*/}
			{/*	/>*/}
			{/*))}*/}
			{squares.map((square, index) => (
				<ColorfulSquare key={getMapKey(square, index)} data={square} className={`col-mobile-8 col-tablet-4 col-desktop-6`} />
			))}
		</Container>
	)
}

export default ColorfulSquares
